import { createContext, useContext } from 'react';

interface FormContextValue {
  isLoading: boolean;
}

export const FormContext = createContext<FormContextValue>({
  isLoading: false
});

export const useFormContext = () => useContext(FormContext);
